import React, {useEffect, useState} from 'react'
import midiToNote from '../../utils/midiToNote'
import seqStore from '../../store/seqStore'

export default function DisplayNote({ colour, track }) {
    // store states
    const melody = seqStore((state) => state.melody)
    const melody_scale = seqStore((state) => state.melody_scale)
    const euclideanPattern = seqStore((state) => state.settings.euclideanPattern)
    const playhead = seqStore((state) => state.settings.playhead)
    const semitone = seqStore((state) => state.settings.semitone)
    const octave = seqStore((state) => state.settings.octave)
    const scale = seqStore((state) => state.settings.scale)

    // useState states
    const [displayNote, setDisplayNote] = useState(null)

    // predict next note to display
    useEffect(()=> {
        let noteToDisplay
        if (playhead[track] === -1) {
            //setDisplayNote("stop")
            setDisplayNote("")
        }
        else if (euclideanPattern[track][playhead[track]] === 1) {
            if (scale[track] !== 0) {
                noteToDisplay = midiToNote(melody_scale[track][playhead[track]] + (octave[track] * 12) + semitone[track])
            } else {
                noteToDisplay = midiToNote(melody[track][playhead[track]] + (octave[track] * 12) + semitone[track])
            }
            setDisplayNote(noteToDisplay)
        } else {
            return // don't display the non active note but the previous active note
        }
    },[playhead, euclideanPattern, setDisplayNote, melody])

    return (
        <div id='displayWrapper'>
            <div id='displayCounterWrapper'>
                <p id='currentNote' style={{color: colour}}>{displayNote}</p>
            </div>
        </div>
    )
}
